module.exports = __webpack_public_path__ + "static/assets/66ae9ffe530e6c00fe138744da19461e.svg";